module.exports = __webpack_public_path__ + "img/pro_two_2.5fd132f3.jpg";